(function () {
  function initBusinessApplyModal() {
    var modal = document.querySelector('[data-business-apply-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    var dialog = modal.querySelector('.business-apply-modal__dialog');
    var previousFocus = null;
    var observedRoots = new WeakSet();
    var refreshQueued = false;
    var fieldFixId = 'business-apply-field-spacing-fix';
    var fieldFixCss = '*,*::before,*::after{box-sizing:border-box!important}input:not([type="checkbox"]):not([type="radio"]):not([type="file"]){min-height:48px!important;padding-top:19px!important;padding-bottom:5px!important;line-height:20px!important}textarea{padding-top:31px!important;line-height:20px!important}label[for]{top:15px!important;translate:0!important}[class*="file"],[class*="upload"]{max-width:100%!important}[class*="error"],[role="alert"]{max-width:100%!important;white-space:normal!important;overflow-wrap:anywhere!important;word-break:break-word!important}[data-business-success-heading]{margin:0 0 12px!important;font-family:var(--business-apply-heading-font)!important;font-size:var(--business-apply-heading-size)!important;font-style:var(--business-apply-heading-style)!important;font-weight:var(--business-apply-heading-weight)!important;line-height:var(--business-apply-heading-line-height)!important;letter-spacing:var(--business-apply-heading-letter-spacing)!important;text-transform:var(--business-apply-heading-transform)!important}[data-business-success-text]{margin:0!important;font-family:var(--business-apply-copy-font)!important;font-size:var(--business-apply-copy-size)!important;font-style:var(--business-apply-copy-style)!important;font-weight:var(--business-apply-copy-weight)!important;line-height:var(--business-apply-copy-line-height)!important;letter-spacing:var(--business-apply-copy-letter-spacing)!important}';

    function scheduleRefresh() {
      if (refreshQueued) return;
      refreshQueued = true;
      window.requestAnimationFrame(function () {
        refreshQueued = false;
        refreshFieldFixes();
      });
    }

    function observeRoot(root) {
      if (!root || observedRoots.has(root)) return;
      observedRoots.add(root);
      new MutationObserver(scheduleRefresh).observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    function syncReferenceStyles() {
      var heading = modal.querySelector('.business-apply-modal__header h2');
      var copy = modal.querySelector('.business-apply-modal__header > div');
      if (!heading || !copy) return;

      var headingStyle = window.getComputedStyle(heading);
      var copyStyle = window.getComputedStyle(copy);
      dialog.style.setProperty('--business-apply-heading-font', headingStyle.fontFamily);
      dialog.style.setProperty('--business-apply-heading-size', headingStyle.fontSize);
      dialog.style.setProperty('--business-apply-heading-style', headingStyle.fontStyle);
      dialog.style.setProperty('--business-apply-heading-weight', headingStyle.fontWeight);
      dialog.style.setProperty('--business-apply-heading-line-height', headingStyle.lineHeight);
      dialog.style.setProperty('--business-apply-heading-letter-spacing', headingStyle.letterSpacing);
      dialog.style.setProperty('--business-apply-heading-transform', headingStyle.textTransform);
      dialog.style.setProperty('--business-apply-copy-font', copyStyle.fontFamily);
      dialog.style.setProperty('--business-apply-copy-size', copyStyle.fontSize);
      dialog.style.setProperty('--business-apply-copy-style', copyStyle.fontStyle);
      dialog.style.setProperty('--business-apply-copy-weight', copyStyle.fontWeight);
      dialog.style.setProperty('--business-apply-copy-line-height', copyStyle.lineHeight);
      dialog.style.setProperty('--business-apply-copy-letter-spacing', copyStyle.letterSpacing);
    }

    function inspectFormRoot(root, state) {
      if (!root || !root.querySelectorAll) return;
      observeRoot(root);

      if (root.host && !root.querySelector('#' + fieldFixId)) {
        var style = document.createElement('style');
        style.id = fieldFixId;
        style.textContent = fieldFixCss;
        root.appendChild(style);
      }

      root.querySelectorAll('*').forEach(function (element) {
        var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        var childMatches = Array.prototype.some.call(element.children || [], function (child) {
          var childText = (child.textContent || '').replace(/\s+/g, ' ').trim();
          return childText === 'Success' || childText.indexOf('Thank you.') === 0 || childText.indexOf('The form has been submitted') !== -1;
        });

        if (!childMatches && text === 'Success') {
          element.setAttribute('data-business-success-heading', '');
          state.success = true;
        } else if (!childMatches && (text.indexOf('Thank you.') === 0 || text.indexOf('The form has been submitted') !== -1)) {
          element.setAttribute('data-business-success-text', '');
          state.success = true;
        }

        if (element.shadowRoot) inspectFormRoot(element.shadowRoot, state);
      });
    }

    function refreshFieldFixes() {
      var state = { success: false };
      syncReferenceStyles();
      inspectFormRoot(modal, state);
      modal.classList.toggle('is-success', state.success);
    }

    function openModal(trigger) {
      previousFocus = trigger || document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('business-apply-modal-open');
      refreshFieldFixes();
      window.setTimeout(refreshFieldFixes, 200);
      window.setTimeout(refreshFieldFixes, 800);
      window.requestAnimationFrame(function () { dialog.focus(); });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.documentElement.classList.remove('business-apply-modal-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-business-apply-open], a[href="#business-apply-form"]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }
      if (event.target.closest('[data-business-apply-close]')) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    window.addEventListener('resize', scheduleRefresh);

    refreshFieldFixes();
    window.setTimeout(refreshFieldFixes, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBusinessApplyModal);
  } else {
    initBusinessApplyModal();
  }

  document.addEventListener('shopify:section:load', initBusinessApplyModal);
})();
